import React from "react";
import { Link} from "react-router-dom";
import siteLogo from "../../../assets/images/logo_new.png"

const ForgotPassword = () => {
    return (
        <div className="signup-wrapper-area payment-wrapper">
            <div className="quick-start-section">
                    <div className="logo-center">
                        <Link to="https://cardiast.com" target="_blank"><img src={siteLogo} alt="Cardiast Logo" /></Link>
                    </div>
                    <div className="signIn-wrapper">
                        <h2 className="form-title">Forgot Password</h2>
                        <p>Enter your email and we'll send you a link to reset your password.</p>
                        <form 
                            action="https://sci.prismict.com/api/store/order/email" 
                            className="action-form signIn-form" 
                            method="POST"
                        >
                            <div className="form-wrapper">
                                <div className="form-group">
                                    <label htmlFor="userEmail">Email</label>
                                    <input 
                                        id="userEmail" 
                                        type="email" 
                                        className="form-control" 
                                        name="email" 
                                        required
                                        placeholder="E.g. example@cardiast.com"
                                    />
                                </div> 
                                <div className="form-group">      
                                    <button 
                                        type="submit" 
                                        className="btn continue_button submit_button btn-primary btn-block mt-4"
                                    >
                                        Submit
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                            <path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path>
                                        </svg>
                                    </button>  
                                </div>                 
                            </div>                    
                        </form>      
                    </div>
                    <div className="signup-footer d-flex">
                        <Link className="back_home_btn btn btn-block" to="/login">
                                    <i className="ri-arrow-left-line"></i> 
                                    Back to login
                        </Link>
                    </div>
                </div>
        </div>
    );
}

export default ForgotPassword;
